export {
    Type,
    instanceOf,
    create,
    toString,
    equals,
    JSON_DISCRIMINATOR,
    Serializable,
    toTypedJSON,
    toUnwrappedJSON,
    fromUnwrappedJSON,
    fromTypedJSON,
    toSchemaValue,
    fromSchemaValue,
    fromSerializable,
    toSerializable,
    SchemaValue,
} from '../../types/ContractAddress.js';
